
var dhx_dragSomethingInTree = (function () {
    function dhx_dragSomethingInTree() {
        this.lWin = window;
    }
    dhx_dragSomethingInTree.prototype._createDragNode = function (c) {
        var a = document.createElement("div");
        a.style.position = "absolute";
        a.innerHTML = c.innerHTML || c.value;
        a.className = "dragSpanDiv";
        return a;
    };
    ;
    dhx_dragSomethingInTree.prototype._preventNsDrag = function (a) {
        (a || window.event).cancelBubble = true;
        if (a && a.preventDefault) {
            a.preventDefault();
            return false;
        }
        return false;
    };
    ;
    dhx_dragSomethingInTree.prototype._nonTrivialNode = function (c, e, a, g) {
        if (this._customDrop) {
            return this._customDrop(c, g.img.id, e.id, a ? a.id : null);
        }
        var h = g.img.getAttribute("image") || "";
        var m = g.img.id || "new";
        var l = g.img.getAttribute("text") ||
            (window._isIE ? g.img.innerText : g.img.textContent);
        c[a ? "insertNewNext" : "insertNewItem"](a ? a.id : e.id, m, l, "", h, h, h);
    };
    return dhx_dragSomethingInTree;
})();
export default dhx_dragSomethingInTree;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXTreeObject/dhx_dragSomethingInTree.js